import { namespace } from 'vuex-class';
import { IDeleteDirectoryState } from './delete-directory.types';

export const DeleteDirectory = namespace('contentLibrary/directories/deleteDirectory');

export const state: IDeleteDirectoryState = {
  deleted: false,
  deleting: false,
};

export enum EDeleteDirectoryAction {
  Delete = 'delete',
  DeleteSuccess = 'deleteSuccess',
  DeleteFailed = 'deleteFailed',
  Reset = 'reset',
}

export enum EDeleteDirectoryMutation {
  SetDeleting = 'setDeleting',
  SetDeleted = 'setDeleted',
  SetState = 'setState',
}
